// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-container {\n    padding: 16px 0px;\n}\n\n.social-container > a {\n    padding: 0px 10px;\n    color: white;\n}\n\n/* .social-container > a:hover {\n    color: #D4AF37;\n} */\n", ""]);
// Exports
module.exports = exports;
